module.exports = {
    nonMemberCategory: {
        1: 'IBBI Registered Valuer', 
        //2: 'Sponsor Deligate', 
        3: 'Foreign Deligates', 
        4: 'Others'
    },
    Registertype: {
        1: 'Registeration', 
        2: 'Residential Registeration'
    },
    Usertype:{1:'Accompanying Delegate',2:"Delegate",3:"Guest",4:"Media",5:"Organiser",6:"Speaker",7:"Sponsor",8:"VIP",9:"Exhibitor"},
    Activities: {1:'Day 1 - Entry',2:"Day 1 - Kit Handover",3:"Day 1 - Dinner",4:"Day 2 - Check-in",5:"Day 2 - Lunch",6:"Day 3 - Check-in",7:"Day 3 - Lunch",8:"Day 3 - Certificate"},
    Activities_1: {1:'Day 1 - Entry',2:"Day 1 - Kit Handover",3:"Day 1 - Dinner"},
    Activities_2: {4:"Day 2 - Check-in",5:"Day 2 - Lunch"},
    Activities_3: {6:"Day 3 - Check-in",7:"Day 3 - Lunch",8:"Day 3 - Certificate"},

    
    iovivcMetadata: {
        "/": {
            title: "57th Indian Valuers Congress | IVC 2026 | Jaipur, Rajasthan",
            description: "57th Indian Valuers Congress, the largest gathering of the valuer fraternity, will be held in December in Jaipur, Rajasthan.",
            metaKeywords: "",
            canonical: "https://iovivc.com/",
            ogType: "website",
            ogTitle: "57th Indian Valuers Congress 2026",
            ogDescription: "Official event website of the 57th Indian Valuers Congress 2026 by Institution of Valuers.",
            ogImage: "https://iovivc.com/api/img/banners/1778043432000.jpeg",
            twitterTitle: "57th Indian Valuers Congress 2026",
            twitterDescription: "Official website of IVC 2026 by Institution of Valuers.",
            twitterImage: "https://iovivc.com/api/img/banners/1778043432000.jpeg"
        },
        "/page/about-us": {
            title: "About Us - Indian Valuers Congress | IVC 2026",
            description: "Learn about the Indian Valuers Congress (IVC) and its mission to advance valuation standards and foster collaboration among professionals in India",
            metaKeywords: ""
        },
        "/ivc-event-schedule": {
            title: "IVC 2026 Event Schedule",
            description: "View the official event schedule, conference sessions, timings, and activities of IVC 2026.",
            metaKeywords: "",
            canonical: "https://iovivc.com/ivc-event-schedule",
            ogTitle: "IVC 2026 Event Schedule",
            ogDescription: "IVC 2026 schedule and session timings.",
            ogImage: "https://iovivc.com/api/img/banners/1778749853896.png"
        },
        "/event/gallery": {
            title: "Gallery | Indian Valuers Congress",
            description: "Explore event photos, conference highlights, and memorable moments from the Indian Valuers Congress event.",
            metaKeywords: "",
            canonical: "https://iovivc.com/event/gallery",
            ogTitle: "IVC Event Gallery",
            ogDescription: "Conference highlights and gallery images from Indian Valuers Congress.",
            ogImage: "https://iovivc.com/api/img/banners/1778749853896.png"
        },
        "/contact": {
            title: "Contact Us | Indian Valuers Congress (IVC) 2026",
            description: "Get in touch with us for inquiries about the Indian Valuers Congress 2026. We’re here to assist you with any questions or information you need",
            metaKeywords: ""
        },
        "/page/partners": {
            title: "Our Partners | Indian Valuers Congress (IVC) 2026",
            description: "Discover the esteemed partners of the Indian Valuers Congress 2026, showcasing collaboration with industry leaders and organizations dedicated to advancing valuation standards.",
            metaKeywords: ""
        },
        "/page/about-iov": {
            title: "About IOV | Institution of Valuers",
            description: "Institution of Valuers (IOV) is a pioneer organization in valuation Profession in India.",
            metaKeywords: "",
            canonical: "https://iovivc.com/page/about-iov",
            ogTitle: "About Institution of Valuers",
            ogDescription: "Institution of Valuers (IOV) is a pioneer organization in valuation Profession in India.",
            ogImage: "https://iovivc.com/api/img/banners/1778043432000.jpeg"
        },
        "/page/about-ivc": {
            title: "About Indian Valuers Congress 2026 | Valuation Event",
            description: "Know more about the Valuation event 57th Indian Valuers Congress 2026, its objectives, conference themes and professional significance.",
            metaKeywords: "",
            canonical: "https://iovivc.com/page/about-ivc",
            ogTitle: "About IVC 2026 | Valuation Event",
            ogDescription: "Official details about the 57th Indian Valuers Congress 2026.",
            ogImage: "https://iovivc.com/api/img/banners/1778749853896.png"
        },
        "/page/eminent-speakers": {
            title: "Eminent Speakers | Valuation Event Jaipur",
            description: "Meet the eminent speakers and industry leaders participating in the 57th Indian Valuers Congress 2026.",
            metaKeywords: "",
            canonical: "https://iovivc.com/page/eminent-speakers",
            ogTitle: "Eminent Speakers | Valuation Event Jaipur",
            ogDescription: "Explore keynote speakers and experts at IVC 2026.",
            ogImage: "https://iovivc.com/api/img/banners/1778749853896.png"
        },
        "/page/theme-of-57th-ivc": {
            title: "Theme of 57th Indian Valuers Congress 2026",
            description: "Explore the official theme and discussion focus areas of the 57th Indian Valuers Congress 2026.",
            metaKeywords: "",
            canonical: "https://iovivc.com/page/theme-of-57th-ivc",
            ogTitle: "Theme of 57th Indian Valuers Congress 2026",
            ogDescription: "IVC 2026 theme and professional focus areas.",
            ogImage: "https://iovivc.com/api/img/banners/1778749853896.png"
        },
        "/page/thematic-issues": {
            title: "Thematic Issues | IVC 2026",
            description: "Discover the thematic issues and key valuation topics covered during the 57th Indian Valuers Congress 2026.",
            metaKeywords: "",
            canonical: "https://iovivc.com/page/thematic-issues",
            ogTitle: "Thematic Issues - IVC 2026",
            ogDescription: "Key valuation topics and conference discussions.",
            ogImage: "https://iovivc.com/api/img/banners/1778749853896.png"
        },
        "/page/conference-advisory-group-of-iov": {
            title: "Conference Advisory Group of IOV",
            description: "Meet the conference advisory group and distinguished professionals guiding IVC 2026.",
            metaKeywords: "",
            canonical: "https://iovivc.com/page/conference-advisory-group-of-iov",
            ogTitle: "Conference Advisory Group - IVC 2026",
            ogDescription: "Advisory group and leadership of the Indian Valuers Congress 2026.",
            ogImage: "https://iovivc.com/api/img/banners/1778749853896.png"
        },
        "/page/about-jaipur": {
            title: "About Jaipur | IVC 2026 Venue Information",
            description: "Explore Jaipur, the host city of the 57th Indian Valuers Congress 2026, including attractions, travel, and venue information.",
            metaKeywords: "",
            canonical: "https://iovivc.com/page/about-jaipur",
            ogTitle: "About Jaipur - IVC 2026",
            ogDescription: "Venue city details and travel information for IVC 2026.",
            ogImage: "https://iovivc.com/api/img/banners/1778749853896.png"
        },
        "/faq": {
            title: "FAQ | Valuation Event IVC 2026",
            description: "Frequently asked questions about registration, event participation, travel, accommodation, and conference details.",
            metaKeywords: "",
            canonical: "https://iovivc.com/faq",
            ogTitle: "Valuation Event IVC 2026",
            ogDescription: "Answers to common questions regarding IVC 2026.",
            ogImage: "https://iovivc.com/api/img/banners/1778749853896.png"
        }
    }


}